// Testi della landing HighTicketSales — Mastermind. Angolo: la scala delle skill (prodotto -> persona).
// Citazioni studenti riportate letterali dove disponibili.

export const QUALIFY =
  "Solo per Sales bloccati ai 2-3-5k/Mese. Se non hai mai fatto queste cifre esci subito.";

export const HERO = {
  kicker: "High Ticket Sales Italia - Mentorship Privata",
  h1a: "Raggiungi i €10-15k/Mese Con la Vendita in",
  h1accent: "Nonchalance.",
  h1b: "",
  sub: "Riprendendo il controllo dalla tua vita e agenda. Rimuovendo ansia, gestendo poche obiezioni e con serenità. Scopri Sales Mastery 1.0. Dedicato a Sales bloccati a 2-3-5k/Mese. Scopri il processo.",
  line: "Guarda la lezione. Poi decidi se ha senso per te.",
  ctaPrimary: "Guarda la lezione",
  ctaSecondary: "Oppure candidati direttamente ↓",
};

export const RECOGNITION = {
  index: "01",
  title: "Ascoltami bene. Sei uno dei due. Punto.",
  profiles: [
    {
      tag: "Profilo A",
      name: "Il non valorizzato",
      bodyLines: [
        "Sei fermo sui 2-3k al mese, dentro un team che non ti valorizza.",
        "Ti passano lead profilati male e ti dicono che il problema è tuo.",
        "Ti hanno insegnato a vendere con paradigmi vecchi: il rapport, lasciarlo parlare, la presentazione aziendale.",
        "E quei paradigmi non reggono più.",
        "Ti senti un ingranaggio, non un professionista.",
      ],
    },
    {
      tag: "Profilo B",
      name: "Il performante che sente il soffitto",
      bodyLines: [
        "Porti a casa numeri decenti e sai di essere bravo, ma senti il tetto.",
        "Chiudi, ma non sai perché chiudi.",
        "Quando salta una call non sai cosa hai sbagliato, e quindi non sai replicare.",
        "Ti confronti coi colleghi, lavori troppe call attaccate, vai in burnout.",
        "Hai smesso di crescere da mesi.",
      ],
    },
  ],
  phrasesTitle: "Le frasi che ti giri in testa:",
  phrases: [
    "\u201CMi sento un numero, non un professionista.\u201D",
    "\u201CLavoro di più, ma non guadagno di più.\u201D",
    "\u201CVado avanti a istinto, senza un metodo, senza supporto.\u201D",
    "\u201CCerte call le chiudo, altre le perdo e non capisco perché.\u201D",
    "\u201CNon ho nessuno che mi possa guidare oltre.\u201D",
  ],
  close: "Sono quasi tutti sintomi. Il problema vero non l'hai ancora guardato — ed è esattamente lì che lavoriamo.",
};

export const LADDER = {
  index: "02",
  title: "La scala delle skill",
  intro: "Non è una questione di quanto fatturi. È una questione di che livello vedi in una trattativa.",
  steps: [
    {
      level: "Livello 1",
      focus: "Ne sai tanto del prodotto/nicchia",
      range: "2 – 3k / mese",
      body: "Conosci il prodotto e la nicchia. Le tue domande sono sul prodotto. Chiudi quando capita, e non sai bene perché.",
    },
    {
      level: "Livello 2",
      focus: "Ne sai tanto delle persone ed i loro limiti",
      range: "5 – 20k / mese",
      body: "Vedi identità, blocchi e paure di chi hai davanti. Le domande passano dal prodotto alla persona. Il resto è conseguenza.",
    },
  ],
  promise: "Ti porto dal livello prodotto al livello persona.",
  note: "È misurabile dall'interno: riconosci subito in quale livello stai, senza che debba convincerti di niente. E funziona su qualsiasi cosa tu venda: e-commerce, immobiliare, ristorazione, relazioni, Infoprodotti, servizi B2b.",
  processNote: "Riceverai un processo personalizzato da riadattare a quello che già utilizzi.",
};

export const LESSON = {
  index: "03",
  title: "In questa lezione scoprirai:",
  points: [
    "Perché quello che chiami \u201Cmancanza di tempo\u201D è un sintomo, e qual è il problema che non hai ancora guardato.",
    "La differenza tra sapere del prodotto e sapere della persona — e perché è questa a fissare il tuo tetto.",
    "Perché \u201Csembri a scaletta\u201D non si risolve cambiando script, ma cambiando il livello a cui conduci la call.",
    "L'obiettivo iceberg: quello che il prospect dichiara e quello che lo fa davvero firmare.",
    "Perché \u201Cscavare nel dolore finché non crolla\u201D ti fa perdere proprio i clienti migliori.",
    "Le conseguenze in loop a 2 giorni, 2 settimane, 2 mesi e 2 anni: la leva più sottovalutata della trattativa.",
    "Cosa fare quando a metà call capisci che stai perdendo tempo, e perché dirlo aumenta le chiusure.",
    "Perché confronti i tuoi numeri con quelli di chi vende un'altra cosa, e come smettere di misurarti sulle vanity metrics.",
    "Come chiedere il pagamento dentro la call, con acconto trasparente, senza spezzare il clima.",
    "Perché il vero salto non è tecnico ma identitario — e cosa significa in pratica.",
  ],
};

export const PHASES = {
  index: "04",
  title: "Il percorso, in quattro fasi",
  sub: "Non moduli da guardare. Un processo da prendere, applicare e validare a mercato.",
  items: [
    {
      n: "01",
      name: "Disinstallare",
      body: "Smontiamo quello che ti hanno insegnato e oggi ti affossa: il rapport che non vende, il monologo lasciato correre, il recap del setting che fa suonare la call scriptata, la presentazione aziendale, la gestione obiezioni a formule.",
    },
    {
      n: "02",
      name: "Il processo",
      body: "Frame, conduzione verticale, ricalco, i tre livelli di profondità, problema vs sintomo, obiettivo iceberg, conseguenze in loop, impegno, pitch spezzato, chiusura pulita con acconto trasparente. Copia-e-incolla, poi validato a mercato.",
    },
    {
      n: "03",
      name: "L'identità",
      body: "Lo strato che nessun corso tocca e dove sta il vero salto: lo switch identitario, la prospettiva desiderio-vs-paure, la zona di discomfort, il \u201Cchi devi diventare\u201D al posto del \u201Cche risultato fai\u201D.",
    },
    {
      n: "04",
      name: "La macchina",
      body: "La gestione di te come parte della performance: agenda governata, call divise, lucidità, energia, feedback a monte al marketing e al setter. Il libero professionista contro l'operaio.",
    },
  ],
  formatTitle: "Come lavoriamo",
  format: [
    "Roleplay e training dal vivo, in gruppo: il processo si interiorizza ripetendolo davanti a qualcuno, non leggendolo.",
    "Correzione ancorata al minuto e alla frase: \u201Cal 5:55 hai detto questo, era sbagliato perché, dovevi dire quest'altro\u201D.",
    "Compiti e accountability veri. E se non ci arrivi, la chiave giusta per te non l'ho ancora trovata io.",
  ],
};

export const MENTOR = {
  index: "05",
  title: "Non importa chi sono io, ma chi ca**o puoi diventare tu con un prodotto come Sales Mastery.",
  cta: "Scopri il percorso",
  photo:
    "/img/cover-154400.webp",
  role: "High Ticket Sales Coach",
  points: [
    "Non importa chi sono io, ma chi ca**o puoi diventare tu con un prodotto come Sales Mastery.",
  ],
  highlight: "Sono i miei numeri da venditore, non una promessa su quelli che farai tu.",
  close: "Non te la tiro e non sono un guru: sono uno che è passato di lì. Ti mostro nel pratico invece di raccontartelo — Gordon Ramsay in cucina, non chi commenta da fuori.",
  commissionsCaption: "Storico commissioni come venditore",
  commissions: [
    { fatturato: "€222.677", vendite: "66 vendite" },
    { fatturato: "€210.192", vendite: "56 vendite" },
    { fatturato: "€176.655", vendite: "44 vendite" },
    { fatturato: "€152.187", vendite: "34 vendite" },
  ],
};

export const TESTIMONIALS = {
  index: "06",
  title: "Quello che è successo a chi è entrato",
  intro: "Parole loro, dai questionari che compilano quando entrano.",
  items: [
    {
      name: "Alina",
      note: "L'arco completo, 13 → 31 agosto",
      quote:
        "Alla domanda su cosa deve sapere un sales ha risposto: «l'identità… sei lì per aiutare, non per vendere». Più calma, e stava già insegnando agli altri.",
    },
    {
      name: "Nicolas",
      quote:
        "La call è andata talmente liscia e normale che non ho sentito nessun campanello di allarme del venditore. Parli e agisci per ascoltare davvero, non per vendere.",
    },
    {
      name: "Luca Carmelita",
      quote:
        "In un settore in cui spesso sembra contino soltanto i numeri e l'incasso, questa è stata la differenza principale. Competenza capace di correggere e guidare senza ferire.",
    },
    {
      name: "Giuseppe Tiranno",
      quote:
        "Claudio non ha fatto una vera call di vendita con me, e da venditore mi è piaciuto molto questa cosa.",
    },
    {
      name: "Roberto Pacenza",
      quote: "Svegliati che sei scarso, formati.",
    },
    { name: "[SLOT LIBERO]", quote: null, empty: true },
  ],
  disclaimer:
    "Ogni percorso è diverso. Non sono risultati garantiti, sono cose che sono successe.",
};

export const FORWHOM = {
  index: "07",
  forYou: {
    title: "È per te se:",
    items: [
      "Vendi già e chiudi contratti, ma senti il divario tra quanto vali e quanto incassi.",
      "Vuoi lavorare sull'identità e sul processo, non su uno script da recitare.",
      "Sei disposto alla ripetizione: registrare audio, rivedere le tue call, fare i compiti.",
      "Vendi qualcosa in cui credi davvero.",
      "Vuoi capire cosa fai già bene per poterlo ripetere a comando.",
    ],
  },
  notForYou: {
    title: "Non è per te se:",
    items: [
      "Non hai mai chiuso un contratto in vita tua.",
      "Cerchi lo script o le \u201Cmagic words\u201D da recitare.",
      "Vendi qualcosa in cui non credi. Se vendi merda, non l'hai imparato da me.",
      "Vuoi risultati senza ripetizione.",
      "Sei un Networker.",
    ],
  },
};

export const LIVE = {
  index: "08",
  cover:
    "/img/cover-23set.webp",
  title: "Roleplay & Training · Live Q&A",
  free: "Live gratuite",
  body: "Call Review & Live Breakdown, Roleplay & Training, Live Q&A. Si lavora davvero, in diretta, su situazioni reali.",
  serious: "Non è una community gratuita con gli amici del bar. È un luogo professionale e serio, dove si lavora.",
  access: "Si accede solo previa conoscenza via telefono. Per entrare fai richiesta e rispondi alle domande del coach.",
  cta: "Fai richiesta d'accesso",
};

export const APPLICATION = {
  index: "09",
  title: "Vuoi saltare la fila?",
  body: "Se hai già capito e non vuoi aspettare lunedì, candidati. Leggo le candidature personalmente e rispondo solo a quelle in target: la stanza non è per tutti e non posso prendere tutti. Se non ha senso per te, te lo dico.",
  blockLabel: "Qual è il tuo blocco principale",
  revenueLabel: "Quanto fatturi di commissioni al mese",
  sellLabel: "Cosa vendi oggi",
  revenueOptions: ["meno di 1.000€", "1.000-3.000€", "3.000-6.000€", "oltre 6.000€"],
  submit: "Scrivimi su WhatsApp",
};

export const FAQ = [
  {
    q: "Quanto costa?",
    a: "Non c'è un prezzo unico: i percorsi sono diversi e si decide insieme quale ha senso. Se non ne ha senso nessuno te lo dico, e non è una frase fatta.",
  },
  {
    q: "Funziona anche se vendo qualcosa di diverso dal tuo settore?",
    a: "Sì. Il metodo lavora sulla persona, non sul prodotto: è stato validato su e-commerce, immobiliare, ristorazione, relazioni, B2B e B2C. Cambia il problema che risolvi, non il modo in cui lo fai emergere.",
  },
  {
    q: "La mia azienda mi forma già gratis. Perché dovrei pagare?",
    a: "Perché la formazione aziendale serve a farti vendere il loro prodotto nel loro modo. Qui impari un mestiere che ti porti dietro, anche quando cambi azienda.",
  },
  {
    q: "Ho già comprato corsi che non hanno mantenuto le promesse.",
    a: "Lo so, ed è il motivo per cui la live del lunedì è gratuita e aperta. Ci vieni, guardi come lavoro su casi veri, e decidi dopo.",
  },
  {
    q: "Ho vent'anni di esperienza. Cosa puoi insegnarmi?",
    a: "Forse niente, e in quel caso te lo dico io per primo. Ma l'esperienza sul campo e il metodo sono due cose diverse, e oggi si impara anche da chi ha iniziato dopo di te.",
  },
  {
    q: "Dove trovo il tempo?",
    a: "È la domanda che si fanno tutti prima di entrare — ed è un sintomo, non il problema. Il percorso è costruito su sessioni concordate e sul lavoro sulle call che stai già facendo, non su ore in più.",
  },
  {
    q: "È l'ennesimo corso sulla gestione delle obiezioni?",
    a: "È il contrario. Serve a non arrivarci mai. Se stai gestendo un'obiezione, hai già sbagliato prima.",
  },
];

export const FOOTER = {
  brand: "HighTicketSales.it",
  links: ["Podcast", "Privacy Policy", "Termini"],
  email: "info@highticketsales.it",
  company: "MSK International LLC",
  copyright: "© 2026 HighTicketSales.it — Tutti i diritti riservati",
  disclaimer:
    "I risultati mostrati sono di persone reali, non sono garantiti e dipendono da impegno, costanza e volume di attività.",
};

// --- Pagina VSL (traffico freddo / retargeting) ---

export const CONTABILI = {
  label: "Cash Collected · Contabili dal Campo",
  cards: [
    { fatturato: "209.186 €", vendite: "61 vendite", dv: "1645%", cash: "179.268 €", dc: "3072%" },
    { fatturato: "193.545 €", vendite: "47 vendite", dv: "2879%", cash: "108.012 €", dc: "5425%" },
    { fatturato: "210.042 €", vendite: "55 vendite", dv: "3133%", cash: "148.612 €", dc: "7502%" },
    { fatturato: "210.192 €", vendite: "56 vendite", dv: "3135%", cash: "167.465 €", dc: "8466%" },
    { fatturato: "222.677 €", vendite: "66 vendite", dv: "3540%", cash: "194.320 €", dc: "4120%" },
    { fatturato: "176.655 €", vendite: "44 vendite", dv: "2210%", cash: "142.910 €", dc: "3390%" },
    { fatturato: "153.193 €", vendite: "29 vendite", dv: "1980%", cash: "127.595 €", dc: "4015%" },
    { fatturato: "152.187 €", vendite: "34 vendite", dv: "1720%", cash: "121.640 €", dc: "2890%" },
  ],
};

export const PRODUCTS = {
  label: "A numero chiuso",
  title: "Risorse private.",
  subtitle: "Un solo percorso a pagamento. Si accede soltanto su candidatura.",
  availability: "5 posti disponibili su 10 per tutto il Q4 2026",
  featuredCover:
    "/img/cover-yt10.webp",
  items: [
    {
      name: "Sales Mastery 1.0",
      logoA: "Sales Mastery",
      logoB: "1.0",
      cover: "/img/sales-mastery-cover-v2.webp",
      type: "Mentorship",
      copy: "Il percorso di affiancamento individuale per diventare un professionista della vendita high ticket.",
      badge: "Su Candidatura",
      link: "Entra in lista d'attesa",
    },
  ],
};

export const FOOTER_VSL = {
  cols: [
    {
      title: "Risorse",
      links: ["Podcast — Venditore Meraviglioso", "YouTube HighTicketSales", "YouTube — Venditore Meraviglioso Podcast"],
    },
    { title: "Percorso privato", links: ["Mentorship"] },
    { title: "Contatti & Legale", links: ["info@highticketsales.it", "Privacy Policy", "Termini"] },
  ],
  disclaimer: "I risultati mostrati sono di persone reali, non sono garantiti e dipendono da impegno, costanza e volume di attività.",
  copyright: "© 2026 HighTicketSales.it — Tutti i diritti riservati",
};
